import React from 'react';
import { authenticateUser, getUserManager } from '@axa-fr/react-oidc-context';

// A spent sign-in code lands here. Forcing a fresh round trip to "/" - never back to this
// URL - is what gets the user in instead of looping on this page.
const signInAgain = () => {
  authenticateUser(getUserManager(), window.location)(true, '/');
};

export const NotAuthenticated = () => (
  <main className="min-h-screen h-full flex items-center px-6 lg:px-32 bg-purple-900 text-white relative">
    <header className="w-full absolute left-0 top-0 p-6 lg:p-32"></header>
    <section className="w-full md:w-9/12 xl:w-8/12">
      <h1 className="text-3xl lg:text-5xl font-bold text-pink-500">Not Authenticated.</h1>
      <button
        type="button"
        className="mt-6 px-4 py-2 rounded bg-pink-500 text-white font-bold"
        onClick={signInAgain}
      >
        Sign in again
      </button>
    </section>
  </main>
);
